export default __webpack_public_path__ + "static/media/White0005.e0c4f200.png";